import { ColorsConfig } from '@ddt-web/config';
import { ObjectUtil } from '@ddt-web/generic-utils';

import { ChartFactory } from '../factories';
import { DefaultChartConfig } from './default-chart.config';
import { ChartType } from './enums/chart-type.enum';

declare const Highcharts;

const DEFAULT_STACKED_GROUPED_COLUMN_CHART_CONFIG = {
	chart: {
		style: {
			fontFamily: 'FortBook, Arial, sans-serif'
		},
		type: ChartType.Column
	},
	plotOptions: {
		series: { stacking: 'normal' },
		column: {
			pointWidth: '12',
			groupPadding: 0.85,
			pointPadding: 0
		}
	},
	xAxis: {
		lineWidth: 0.25,
		lineColor: '#000',
		tickWidth: 0.25,
		tickColor: '#000',
		title: {
			text: 'Scenarios',
			style: {
				color: '#000',
				fontSize: '8px'
			}
		},
		labels: {
			style: {
				color: '#616161',
				fontSize: '8px'
			},
			autoRotationLimit: 40
		}
	},
	yAxis: {
		gridLineWidth: 0.25,
		gridLineColor: '#616161',
		title: {
			text: 'Sensitivity %',
			style: {
				color: '#000',
				fontSize: '8px'
			},
			margin: 10
		},
		labels: {
			style: {
				color: '#616161',
				fontSize: '8px'
			}
		},
		categories: null
	},
	colors: null,
	extensibleData: null
};

export class StackedGroupedColumnChartConfigPdf extends DefaultChartConfig {
	constructor(
		protected type: string,
		protected name: string,
		protected container: HTMLElement,
		protected data: any,
		protected dataIndex?: number,
		protected colors?: Array<string>,
		protected height?: number,
		protected width?: number,
		protected title?: string,
		protected hideTitle?: boolean,
		protected x?: string,
		protected y?: string,
		protected customAttributes?: StackedGroupedColumnChartCustomAttributes
	) {
		super(type, container, colors, height, width, title, hideTitle);
		this.initialize();
	}

	private initialize(): void {
		const defaultConfig = DEFAULT_STACKED_GROUPED_COLUMN_CHART_CONFIG;
		this.setColors();
		this.configuration = ObjectUtil.extend(this.configuration, this.UpdateConfig(defaultConfig));
	}

	public setColors(): void {
		const transformedData = ChartFactory.getStackedColumnData(this.data);
		let colors = this.colors || [];
		transformedData.portfolios.forEach((portfolio, index) => {
			colors = colors.concat(ColorsConfig.SCENARIO_ANALYSIS_COLORS[index]);
		});
		this.colors = colors.reverse();
	}

	public UpdateConfig(config): any {
		const transformedData = ChartFactory.getStackedColumnData(this.data);
		const series = transformedData.series;
		series.reverse();
		config.series = series;
		config.xAxis.categories = transformedData.scenarios;
		config.colors = this.colors;
		return config;
	}

	public getConfigurationForPDF(): any {
		return this.configuration;
	}

	public render(): void {
		Highcharts.chart(this.configuration);
	}
}

export interface StackedGroupedColumnChartCustomAttributes {
	[id: string]: any;
}
